import { useQuery } from '@tanstack/react-query';
import type { DashboardController } from '@/api/dashboard/dashboard.controller';
import { apiClient } from '@/lib/api-client';

// O retorno junta resultados do repositório (prévia, itens com cifra), então o tipo vem dele.
export type DashboardData = Awaited<ReturnType<DashboardController['show']>>;

export const dashboardKeys = { all: ['dashboard'] as const };

export const useDashboard = () =>
  useQuery({
    queryKey: dashboardKeys.all,
    queryFn: async () => {
      const res = await apiClient.dashboard.get();
      return res.data as unknown as DashboardData;
    },
  });
